var script_loaded=!1;function loadJSscripts(){if(!script_loaded){observer.disconnect(),script_loaded=!0,document.querySelectorAll("iframe.lazy").forEach(t=>{datasrc=t.dataset.src,null!=datasrc&&(t.src=datasrc)});var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)if(null!==t[i].getAttribute("data-src")&&(t[i].setAttribute("src",t[i].getAttribute("data-src")),delete t[i].dataset.src),"text/lazyload"==t[i].getAttribute("type")){for(var e=document.createElement("script"),a=0;a<t[i].attributes.length;a++){var n=t[i].attributes[a];e.setAttribute(n.name,n.value)}e.type="text/javascript",e.innerHTML=t[i].innerHTML,t[i].parentNode.removeChild(t[i]),t[i].parentNode.insertBefore(e,t[i])}var r=document.getElementsByTagName("link");for(i=0;i<r.length;i++)null!==r[i].getAttribute("data-href")&&(r[i].setAttribute("href",r[i].getAttribute("data-href")),delete r[i].dataset.href);document.dispatchEvent(new CustomEvent("asyncLazyLoad"))}}var activityEvents=["mousedown","mousemove","keydown","scroll","touchstart","click","keypress","touchmove"];activityEvents.forEach(function(t){window.addEventListener(t,loadJSscripts,!1)}),window.addEventListener?window.addEventListener("load",function(){},!1):window.attachEvent?window.attachEvent("onload",function(){}):window.onload=(t=>{});

document.addEventListener("DOMContentLoaded", function () {
  console.log("Loopsy License Generator script loaded");

  // Loosened path check
  if (!window.location.pathname.toLowerCase().includes("license")) {
    console.log("Not on license page. Exiting script.");
    return;
  }

  let currentLicense = '';

  const generateBtn = document.getElementById('generate-btn');
  const downloadBtn = document.getElementById('download-btn');

  if (generateBtn && downloadBtn) {
    console.log("Buttons found. Binding events...");

    generateBtn.addEventListener('click', function () {
      console.log("Generate button clicked.");
      const name = document.getElementById("name").value;
      const email = document.getElementById("email").value;
      const product = document.getElementById("product").value;
      const date = document.getElementById("date").value;
      const id = 'LPSY-' + Math.floor(Math.random() * 900000 + 100000);
      const today = new Date().toISOString().split('T')[0];

      currentLicense = `
LICENSE CERTIFICATE

Issued to: ${name}
Email: ${email}
Product: ${product}
Purchase Date: ${date}
License ID: ${id}
Issued: ${today}

Rights Granted:
• Use in personal and commercial music projects
• Distribution on major streaming platforms (Spotify, YouTube, Apple Music, etc.)
• Retain 100% of royalties unless otherwise negotiated

Restrictions:
• No resale or redistribution of raw files
• No uploading to sample marketplaces or NFTs
• No exclusive claims to original source material

Legal:
This license is governed by Loopsy’s Terms of Use and Terms of Service.
Retroactive licensing applies to high-impact commercial use:
- 1M+ streams
- Major label signings
- Sync placements or broadcast media

Keep this license as proof of commercial rights.

Loopsy Ltd
Liverpool, UK
https://loopsy.store/pages/terms-of-use
https://loopsy.store/pages/terms-of-service
      `;

      document.getElementById("license").innerText = currentLicense;

      // ✅ Send license data to Make.com webhook
      fetch("https://hook.eu2.make.com/gu98s52arza838i1zrsyrczmq1uaxwdq", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: name,
          email: email,
          product: product,
          purchase_date: date,
          license_id: id,
          date_issued: today
        })
      })
      .then(res => console.log("✅ License data sent to Google Sheet"))
      .catch(err => console.error("❌ Webhook error:", err));
    });

    downloadBtn.addEventListener('click', function () {
      console.log("Download button clicked.");
      if (!currentLicense) {
        alert("Please generate the license first.");
        return;
      }

      const { jsPDF } = window.jspdf;
      const doc = new jsPDF();
      const lines = doc.splitTextToSize(currentLicense, 180);
      doc.text(lines, 10, 10);
      doc.save("Loopsy_License_Certificate.pdf");
    });
  } else {
    console.warn("Buttons not found — make sure HTML IDs are correct and visible.");
  }
});